import React from "react";
import { HeroSlider } from "../components/home/HeroSlider";
import { BrandMarquee } from "../components/home/BrandMarquee";
import { CollectionRail } from "../components/home/CollectionRail";
import { BestSellers } from "../components/home/BestSellers";
import { NeedBanners } from "../components/home/NeedBanners";
import { ProductSpotlight } from "../components/home/ProductSpotlight";
import { SevenSinsSpotlight } from "../components/home/SevenSinsSpotlight";
import { HoneyBar } from "../components/home/HoneyBar";
import { Testimonials } from "../components/home/Testimonials";
export function Home() {
  return <>
      <HeroSlider data-id="element-380" data-mp="29ek3mwsf77yr" />
      <BrandMarquee data-id="element-381" data-mp="29i7xjx1s1we0" />
      <CollectionRail data-id="element-382" data-mp="2dhqk0x98yfiy" />
      <BestSellers data-id="element-383" data-mp="2dhywio1gjitm" />
      <NeedBanners data-id="element-384" data-mp="2dii3xatheote" />
      <ProductSpotlight data-id="element-385" data-mp="2dj1nsx2ozna2" />
      <SevenSinsSpotlight data-id="element-386" data-mp="3kvafavfm4rzr" />
      <HoneyBar data-id="element-387" data-mp="3kw1z78zul1a7" />
      <Testimonials data-id="element-388" data-mp="3ku8u3y4vup4b" />
    </>;
}